export function resolveHookState(nextState, currentState) {
    if (typeof nextState === 'function') {
        return nextState.length ? nextState(currentState) : nextState();
    }
    return nextState;
}



//////////////////
// WEBPACK FOOTER
// ./~/react-use/esm/misc/hookState.js
// module id = 226
// module chunks = 2